import { render } from "./PrimaryInsurance.vue?vue&type=template&id=020810f0"
import script from "./PrimaryInsurance.vue?vue&type=script&lang=js"
export * from "./PrimaryInsurance.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/orders/billingInfo/forms/PrimaryInsurance.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "020810f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('020810f0', __exports__)) {
    console.log('reload')
    api.reload('020810f0', __exports__)
  }
  
  module.hot.accept("./PrimaryInsurance.vue?vue&type=template&id=020810f0", () => {
    console.log('re-render')
    api.rerender('020810f0', render)
  })

}


export default __exports__